import { FlowerPollenOutlineIcon } from './FlowerPollenOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 24A80A28-E963-4E59-BA21-9D97C0434950
 * name flower-pollen-outline
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flower-pollen-outline.svg
 * tags
 * - Nature 
 * - Agriculture 
 */
export const AllergyOutlineIcon = FlowerPollenOutlineIcon;
export default AllergyOutlineIcon